import React from "react";

function MqttBoxIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75 7.90527L9.75 10.1553L6.75 12.4053M11.25 12.4053H14.25M5.25 20.6553H18.75C19.3467 20.6553 19.919 20.4182 20.341 19.9963C20.7629 19.5743 21 19.002 21 18.4053V6.40527C21 5.80854 20.7629 5.23624 20.341 4.81428C19.919 4.39233 19.3467 4.15527 18.75 4.15527H5.25C4.65326 4.15527 4.08097 4.39233 3.65901 4.81428C3.23705 5.23624 3 5.80854 3 6.40527V18.4053C3 19.002 3.23705 19.5743 3.65901 19.9963C4.08097 20.4182 4.65326 20.6553 5.25 20.6553Z"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default MqttBoxIcon;
